import { render, staticRenderFns } from "./StatisticPromotionCouponIframe.vue?vue&type=template&id=3e402ef6&"
import script from "./StatisticPromotionCouponIframe.vue?vue&type=script&lang=ts&"
export * from "./StatisticPromotionCouponIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports